export const FACET_SEARCH_ROUTE_QUERY_PARAM = "searchTerm" as const;
export const SHIPPING_DATE_FILTER_QUERY_PARAM = "shippingDate" as const;
